export default {
  init() {
    // JavaScript to be fired on the home page

    // Fade video on scroll
    $(window).scroll(function(){
        $(".masthead__video").css("opacity", 1 - $(window).scrollTop() / ($('.masthead__video').height() / 2));
    });
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/home.js